<template>
    <div>
        <section class="q10__jumbotron relative">
            <hotspot-richmedia
                :options="{
                    icon: 'diaporama',
                    collection: getRichmediaByCollection(
                        currentPage,
                        `La STEP d’Hatta à Dubaï`
                    ),
                }"
                class="bottom-2 lg:bottom-2 left-2"
            />
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.image1.src,
                    descriptions: [
                        {
                            text: currentPage.images.image1.edf,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
            
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 my-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-resolution_blue',
                        to: 'to-dodger_blue',
                    }"
                >
                    <h1 v-html="currentPage.content.pageTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.pageDescription.text"
                ></p>

                <div class="container-components">
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-dodger_blue',
                            }"
                        >
                        <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="currentPage.content.firstSubTitle.text"
                            ></span>
                            
                        </TitleParagraph>
                        
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="currentPage.content.firstParagraph.text"
                            >
                            </span>
                            
                        </paragraph>
                    </div>
                    <div class="card break-inside-avoid">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-dodger_blue',
                            }"
                        >
                            <span
                                v-html="currentPage.content.secondSubTitle.text"
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.secondParagraph.text
                                "
                            >
                            </span>
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'bottom',
                                }"
                            />
                        </paragraph>
                       

                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image2.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image2.alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="card">
                        <div class="relative">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        `Gilboa, de l’hydro dans le mix israélien`
                                    ),
                                }"
                                class="top-2 right-2"
                            />
                        </div>
                        <image-with-descriptions class="eliminate-margin"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image3.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image3.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-dodger_blue',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="currentPage.content.thirdSubTitle.text"
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="currentPage.content.thirdParagraph.text"
                            >
                            </span>
                        </paragraph>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-dodger_blue',
                            }"
                        >
                            <span
                                v-html="currentPage.content.fourthSubTitle.text"
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.fourthParagraph.text
                                "
                            >
                            </span>
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'bottom',
                                }"
                            />
                        </paragraph>
                    </div>

                    <div>
                        <image-with-descriptions class="eliminate-margin"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image4.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image4.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div>
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image5.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image5.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-dodger_blue',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#00357f', '#0b4f9c', '#0d94ff'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="currentPage.content.fifthSubTitle.text"
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="currentPage.content.fifthParagraph.text"
                            >
                            </span>
                            <!-- <square
                                :options="{
                                    from: 'from-resolution_blue',
                                    to: 'to-dodger_blue',
                                }"
                            /> -->
                        </paragraph>
                    </div>
                </div>
                <div class="relative mt-8">
                    <TitleParagraph
                            :options="{
                                from: 'from-resolution_blue',
                                to: 'to-dodger_blue',
                            }" class="text-center"
                        > 
                            <span class="text-xl md:text-2xl lg:text-3xl"
                                v-html="currentPage.content.sixthParagraph.text"
                            ></span>
                        </TitleParagraph>
                    <image-with-descriptions style="margin:0;"
                        :options="{
                            image:
                                'pages/' +
                                currentPage.slug +
                                '/' +
                                currentPage.images.image6.src,
                            descriptions: [],
                        }"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang="scss">
</style>
